"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Styled = void 0;
var _taggedTemplateLiteral2 = _interopRequireDefault(require("@babel/runtime/helpers/taggedTemplateLiteral"));
var _core = require("@material-ui/core");
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _theme = require("../theme");
var _templateObject;
var spacing = _theme.theme.spacing;
var Styled = (0, _styledComponents["default"])(_core.Paper)(_templateObject || (_templateObject = (0, _taggedTemplateLiteral2["default"])(["\n  :global(.root) {\n    width: 100%;\n    margin-top: ", "px;\n  }\n  :global(.table) {\n    min-width: 1020px;\n  }\n  :global(.tableWrapper) {\n    overflow-x: auto;\n  }\n"])), spacing() / 2);
exports.Styled = Styled;